<p-tabs [value]="value" (valueChange)="onChange($event)">
  @if (tabs.length > 1 || !hideTabListIfSingle) {
    <p-tablist class="flex-shrink-0">
        @for (t of tabs; track getTabTrack(t, $index); let index = $index) {
        <p-tab [class]="t.tabClass" [style]="t.tabStyle" [value]="getTabValue(t, index)" [disabled]="t.disabled">
            <span class="sm-tab-header-label">
                {{ t.header }}
                @if (t.headerBadge != null && t.headerBadge !== '' && t.headerBadge !== 0) {
                <p-badge class="sm-tab-header-badge" [value]="'' + t.headerBadge" [severity]="t.headerBadgeSeverity" [pTooltip]="t.headerBadgeTooltip"></p-badge>
                }
            </span>
            @for (icon of t.headerIcons ?? []; track icon) {
            <span [class]="icon"></span>
            }
            @if (t.closable) {
            <span class="fas fa-times ml-2" (click)="close(getTabValue(t, index), $event)" style="cursor:pointer"></span>
            }
        </p-tab>
        }
    </p-tablist>
  }
  <p-tabpanels>
    @for (t of tabs; track getTabTrack(t, $index); let index = $index) {
      <p-tabpanel [value]="getTabValue(t, index)">
        @if (shouldRenderTab(t, index)) {
          <ng-template [cdPaused]="isTabChangeDetectionPaused(t, index)" [cdPausedTemplate]="t.contentTpl"></ng-template>
          @if (isTabPreparing(t, index)) {
            <div class="sm-tab-content-preparing" aria-busy="true"></div>
          }
        }
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
